(function () {
  const TERMS = [
    {
        "term": "Bro",
        "meta": "(n) (BROH)",
        "definition": "a lifelong amigo who's got your back and you can always count on. Sometimes goes by 'broooo,' 'bruh,' or 'brah' in other cultures.",
        "examples": [
            "He’s the 3 a.m. call who actually shows up — peak bro.",
            "Need backup? Summon the resident bro and breathe."
        ]
    },
    {
        "term": "Bro-bono",
        "meta": "(adj) (broh-BOH-no)",
        "definition": "when you do a less fortunate bro a favor for free",
        "examples": [
            "Spotting your bro on weights he can't lift? — Bro-bono.",
            "9th dating tip this week... bro-bono hours are piling up."
        ]
    },
    {
        "term": "Bro-bq",
        "meta": "(n) (broh-BEE-kew)",
        "definition": "a barbecue with the bros, often featuring samgyupsal",
        "examples": [
            "Samgyupsal, we all know, is the true king of Korean bro-bq.",
            "The July 4th bro-bq turned into a disaster."
        ]
    },
    {
        "term": "BroandTell",
        "meta": "(n) (broh-and-TELL)",
        "definition": "a teaching method employed by wise bros from Plato to Gronk",
        "examples": [
            "He popped the trunk and kicked off an impromptu bro and tell.",
            "“Observe,” she said, stacking burgers like slides — bro and tell complete."
        ]
    },
    {
        "term": "Brobarian",
        "meta": "(n) (broh-BAYR-ee-uhn)",
        "definition": "a savage bro who solves everything with brute strength and loudness",
        "examples": [
            "The brobarian treats moving furniture like it's a strong-man competition.",
            "Need a bottle opened? Brobarian uses his teeth."
        ]
    },
    {
        "term": "Brobation",
        "meta": "(n) (broh-BAY-shun)",
        "definition": "when a bro is sentenced for wrongdoing",
        "examples": [
            "His endless attempt at karaoke is calling for brobation.",
            "The committee of bros has spoken: brobation."
        ]
    },
    {
        "term": "Brobot",
        "meta": "(n) (broh-BAWT)",
        "definition": "an emotionless bro who replies only with short words like “k,” “lol,” or a thumbs-up emoji",
        "examples": [
            "His brobot replies left the group wondering if he even read the messages.",
            "Talking to the brobot feels like texting an answering machine."
        ]
    },
    {
        "term": "Brocedures",
        "meta": "(n) (broh-SEE-jurz)",
        "definition": "instructions passed down from bro to bro",
        "examples": [
            "Our road-trip brocedures even include designated nap rotations.",
            "He laminated the brocedures and added emergency salsa rules."
        ]
    },
    {
        "term": "Brochacho",
        "meta": "(n) (broh-CHA-choh)",
        "definition": "a bro of Latin origins",
        "examples": [
            "Brochacho flipped the tortilla and the vibe.",
            "Snow up to his knees but still rocking slides... brochacho."
        ]
    },
    {
        "term": "Brochella",
        "meta": "(n) (broh-CHEL-uh)",
        "definition": "a full-scale party hosted by a bro in his backyard",
        "examples": [
            "Last weekend we had truly one of the greatest brochellas ever.",
            "Our annual brochella is coming up this month."
        ]
    },
    {
        "term": "Brocrastinate",
        "meta": "(v) (broh-KRAS-tuh-nayt)",
        "definition": "to delay responsibilities in favor of chilling",
        "examples": [
            "Saturday mornings are the perfect time to brocrastinate with snacks and video games.",
            "They brocrastinated so long on grocery shopping that dinner became cereal."
        ]
    },
    {
        "term": "Brocringe",
        "meta": "(adj) (broh-CRINJ)",
        "definition": "when a bro behaves so awkwardly that even other bros physically shiver",
        "examples": [
            "It was a definite brocringe when he brought a selfie stick to the gym.",
            "It turned brocringe fast when he introduced himself as an influencer."
        ]
    },
    {
        "term": "Brodependent",
        "meta": "(adj) (broh-dih-PEN-duhnt)",
        "definition": "when you and bro truly need each other",
        "examples": [
            "He won't RSVP without me; our calendars are brodependent.",
            "Finals week turns us into a brodependent study organism."
        ]
    },
    {
        "term": "Broexist",
        "meta": "(v) (broh-EGG-zist)",
        "definition": "when you and bro decide to stop beefing",
        "examples": [
            "After the DM apology, we agreed to broexist for the trip.",
            "Can we broexist through the playoffs and argue in July?"
        ]
    },
    {
        "term": "Brofanity",
        "meta": "(n) (broh-FAN-ih-tee)",
        "definition": "language unbecoming of a bro",
        "examples": [
            "Gentle reminder: curb the brofanity near the nieces.",
            "The ref heard the brofanity and called a technical foul."
        ]
    },
    {
        "term": "Brofessional",
        "meta": "(n) (broh-FESH-uh-nuhl)",
        "definition": "when you bro so hard, people pay you for it.",
        "examples": [
            "He negotiated a sponsor mid-party — classic brofessional.",
            "She invoices for vibes because she's that brofessional."
        ]
    },
    {
        "term": "Brofessors",
        "meta": "(n) (broh-FESS-urz)",
        "definition": "learned bros of the highest rank",
        "examples": [
            "Two brofessors audited our Tinder profiles and assigned homework.",
            "The brofessors circled the whiteboard like hawks of wisdom."
        ]
    },
    {
        "term": "Broflex",
        "meta": "(v) (broh-FLEKS)",
        "definition": "to unnecessarily brag about achievements just to impress fellow bros",
        "examples": [
            "He broflexed casually by mentioning his PR on deadlifts during trivia night.",
            "Even in his apology, Gus was broflexing: “Sorry I'm late, had to finish my 10K run.”"
        ]
    },
    {
        "term": "Brogammer",
        "meta": "(n) (broh-GRAM-er)",
        "definition": "a code-loving bro who only leaves the room for snacks and energy drinks",
        "examples": [
            "The brogammer missed the party because he was deep into debugging until 3 a.m.",
            "The brogammer only speaks up when the Wi-Fi goes down."
        ]
    },
    {
        "term": "Brogram",
        "meta": "(n) (broh-GRAM)",
        "definition": "a day plan that includes only bro-related activities",
        "examples": [
            "You don't RSVP to the brogram — you just show up with chips.",
            "The brogram doesn't allow salads unless they're on top of a burger."
        ]
    },
    {
        "term": "Brogue",
        "meta": "(n) (brohg)",
        "definition": "when a bro ignores the brogram and does things his own way",
        "examples": [
            "The squad had Call of Duty night lined up, but Dave pulled a brogue and went on a date.",
            "Brocode violation 101: going brogue without notice."
        ]
    },
    {
        "term": "Brohemian",
        "meta": "(n) (broh-HEE-mee-uhn)",
        "definition": "an artistic bro",
        "examples": [
            "His van doubles as a studio — resident brohemian move.",
            "She tuned the guitar, and the room crowned her a brohemian."
        ]
    },
    {
        "term": "Brohibition",
        "meta": "(n) (broh-hib-ISH-un)",
        "definition": "a dark time when bros are denied access to parties or freedom",
        "examples": [
            "Party rules: no beer pong. Welcome to Brohibition.",
            "During Brohibition, even Gatorade had to be smuggled in red Solo cups."
        ]
    },
    {
        "term": "Broincidences",
        "meta": "(n) (broh-IN-sih-den-suhz)",
        "definition": "a remarkable concurrence between bros without apparent causal connection",
        "examples": [
            "Same shirt, same seat, same joke — stacked broincidences.",
            "We ordered the exact tacos without speaking — broincidences again."
        ]
    },
    {
        "term": "Broke",
        "meta": "(n) (broh-KE)",
        "definition": "a bro who is financially devastated",
        "examples": [
            "Timmy has always been the broke in our group who never offers to pay.",
            "Which path do you choose? A brofessional or a broke?"
        ]
    },
    {
        "term": "Broletariat",
        "meta": "(n) (broh-luh-TAIR-ee-uht)",
        "definition": "working-class bros",
        "examples": [
            "The broletariat runs on coupons.",
            "Weekend OT turned our house into broletariat HQ."
        ]
    },
    {
        "term": "Brolicious",
        "meta": "(adj) (broh-LISH-uhs)",
        "definition": "when it hits your lips and you moan “bro”",
        "examples": [
            "That first bite earned a unanimous “bro” — truly brolicious.",
            "Your cold-brew recipe is dangerous at 7 a.m."
        ]
    },
    {
        "term": "Broliloquy",
        "meta": "(n) (broh-LIL-uh-kwee)",
        "definition": "when a bro muses their thoughts out loud",
        "examples": [
            "Listening to Casey's broliloquy was unbearable.",
            "Tracy's opening broliloquy set the tone for what was to come."
        ]
    },
    {
        "term": "Brolowkey",
        "meta": "(n, adj) (broh-LOH-kee)",
        "definition": "a quietly cool bro who never shows off but always delivers",
        "examples": [
            "The brolowkey showed up to the party with pizza and saved the night.",
            "Never brags, but always knows the Wi-Fi password — brolowkey."
        ]
    },
    {
        "term": "Bromance",
        "meta": "(n) (broh-MANS)",
        "definition": "a unique and holy bond between “brothers from another mother”",
        "examples": [
            "Their handshake turned into a full-length bromance documentary.",
            "The hospital snack run cemented their bromance forever."
        ]
    },
    {
        "term": "Bromotion",
        "meta": "(n) (broh-MOH-shun)",
        "definition": "when a bro rises in the ranks of bros",
        "examples": [
            "After three years of grueling work, Ted got a bromotion.",
            "Bromotion to a tenured brofessor is the final goal."
        ]
    },
    {
        "term": "Broordinates",
        "meta": "(n) (broh-OR-duh-nuhts)",
        "definition": "directions to gatherings of bros",
        "examples": [
            "Drop the broordinates; we're five minutes out.",
            "The AirDropped broordinates arrived like a rescue flare."
        ]
    },
    {
        "term": "Bropocalypse",
        "meta": "(n) (broh-POCK-uh-lips)",
        "definition": "when bros become men and the party ends",
        "examples": [
            "At sunrise, dishes and adulthood — welcome to bropocalypse.",
            "Keys, mortgages, and matching toolboxes — domestic bropocalypse."
        ]
    },
    {
        "term": "Brosimp",
        "meta": "(n) (broh-SIMP)",
        "definition": "a bro who abandons the squad to obsess over a crush",
        "examples": [
            "He skipped poker night to watch her cat... total brosimp move.",
            "He was a solid teammate until brosimp season started."
        ]
    },
    {
        "term": "Brostalgia",
        "meta": "(n) (broh-STAL-juh)",
        "definition": "a sentimental longing or wistful connection to your younger bro days",
        "examples": [
            "Old mixtapes and the cracked GameCube — instant brostalgia.",
            "One whiff of that dorm-room ramen and the brostalgia hit hard.",
            "The bench where we skipped class has permanent brostalgia carved in."
        ]
    },
    {
        "term": "Brostradomus",
        "meta": "(n) (broh-STRAH-duh-muhs)",
        "definition": "a bro who accurately predicts things like world events and college football games",
        "examples": [
            "Steve is a true brostradomus. His March Madness bracket came in very close.",
            "Bad feelings are never wrong. I feel like a brostradomus every time I botch a test."
        ]
    },
    {
        "term": "Brosus",
        "meta": "(adj) (broh-SUSS)",
        "definition": "acting suspiciously to the point where all bros question your motives",
        "examples": [
            "When he locked his phone every time someone walked by, the brosus vibe was heavy.",
            "His sudden interest in yoga after ignoring the squad for weeks had a hint of brosus."
        ]
    },
    {
        "term": "Brotagonist",
        "meta": "(n) (broh-TAG-uh-nist)",
        "definition": "the bro who naturally becomes the main character in every situation",
        "examples": [
            "The brotagonist doesn't chase the spotlight — it just follows him.",
            "No matter where the squad goes, he ends up the brotagonist of the night."
        ]
    },
    {
        "term": "Brotege",
        "meta": "(n) (BROH-tuh-zhay)",
        "definition": "a young bro under the guidance of a more seasoned bro",
        "examples": []
    },
    {
        "term": "Brotisserie",
        "meta": "(n) (broh-TISS-uh-ree)",
        "definition": "a perfectly rotating squad of bros, ensuring everyone gets their time to shine",
        "examples": [
            "Game night operates like a brotisserie — controller passes clockwise, trash talk never stops.",
            "At karaoke, the brotisserie kept the mic moving so every voice got heard."
        ]
    },
    {
        "term": "Brotopia",
        "meta": "(n) (broh-TOH-pee-uh)",
        "definition": "a fictional place of peak broness, sometimes referred to as a mojo dojo casa house",
        "examples": [
            "Games, drinks, wings — the ultimate brotopia.",
            "The bros gathered for the tee-off. Brotopia is here."
        ]
    },
    {
        "term": "Brotox",
        "meta": "(adj) (broh-TOKS)",
        "definition": "extremely toxic behavior that ruins the mood for the entire brogroup",
        "examples": [
            "Nothing kills the atmosphere faster than a dose of brotox during game night.",
            "The night was going fine until his brotox attitude turned every joke into an argument."
        ]
    },
    {
        "term": "Brovado",
        "meta": "(n) (broh-VAH-doh)",
        "definition": "when a bro is so bold as to intimidate",
        "examples": [
            "One move. No words. Just Brovado.",
            "Even in casual conversation, his Brovado was enough to make people step back.",
            "His Brovado at the poker table kept everyone second-guessing their hands."
        ]
    },
    {
        "term": "Broverdrive",
        "meta": "(adj) (broh-VER-drayv)",
        "definition": "the hyperactive mode a bro enters when the party finally hits peak",
        "examples": [
            "His broverdrive moment was grabbing two mics and singing both parts of a duet.",
            "He reached broverdrive at the wedding reception, dancing harder than the bride and groom."
        ]
    },
    {
        "term": "Brovibe",
        "meta": "(n) (broh-VAHYB)",
        "definition": "a subtle, unspoken energy that only bros understand immediately",
        "examples": [
            "On the basketball court, one nod was enough — the brovibe handled the rest.",
            "The brovibe was undeniable as they all leaned back in their chairs at the same time after dinner."
        ]
    },
    {
        "term": "Brovocado",
        "meta": "(n) (broh-vuh-KAH-doh)",
        "definition": "a bro who seems tough on the outside but is surprisingly soft-hearted inside",
        "examples": [
            "He acts like the toughest guy in the gym, but he's really a brovocado who tears up at dog commercials.",
            "He looks like he'll steal your fries, but he's someone who actually offers you his last one — a brovocado."
        ]
    },
    {
        "term": "Brovocative",
        "meta": "(adj) (broh-VAK-uh-tiv)",
        "definition": "deliberately shaking things up, unconcerned by the opinions of bro-haters",
        "examples": [
            "His neon boots were wildly brovocative and somehow... dignified.",
            "The pictures she put up on the screen were extremely brovocative."
        ]
    },
    {
        "term": "Brovorce",
        "meta": "(n, v) (broh-VOR-se)",
        "definition": "when the bromance ends",
        "examples": [
            "Post-season, their fantasy team filed for brovorce.",
            "The Netflix-password custody battle was peak brovorce drama."
        ]
    },
    {
        "term": "Brozilla",
        "meta": "(n) (broh-ZIL-uh)",
        "definition": "a massive-energy bro who shows up and destroys all chill vibes",
        "examples": [
            "Brozilla doesn't just arrive at a party — he tramples it.",
            "Nobody asked for karaoke, but Brozilla grabbed the mic and performed a whole album."
        ]
    },
    {
        "term": "Quid Pro Bro",
        "meta": "(n) (kwid-proh-BROH)",
        "definition": "when you and the bro hook each other up",
        "examples": [
            "Airport ride for moving help — classic quid pro bro.",
            "He fixed my sink; I DJ'd his cousin's wedding. Quid pro bro secured."
        ]
    }
];

  const ROOT_SELECTOR = '[data-bro-word-of-day]';
  const STORAGE_KEY = 'koreanBros.wordOfDay.index';
  const POLL_INTERVAL = 200;

  let currentIndex = -1;
  let currentRoot = null;
  let wasVisible = false;
  let pollTimer = null;

  function readStoredIndex() {
    try {
      const stored = Number(sessionStorage.getItem(STORAGE_KEY));
      return Number.isInteger(stored) && stored >= -1 && stored < TERMS.length
        ? stored
        : -1;
    } catch (error) {
      return -1;
    }
  }

  function storeIndex(index) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(index));
    } catch (error) {
      // Rotation still works when sessionStorage is unavailable.
    }
  }

  function getRoots() {
  return Array.from(document.querySelectorAll(ROOT_SELECTOR));
}

function getRoot() {
  const roots = getRoots();

  if (!roots.length) {
    return null;
  }

  // Prefer the copy currently visible inside the open cart drawer.
  const visibleRoot = roots.find(function (root) {
    return isVisible(root);
  });

  // Shopify often places the active drawer later in the DOM.
  return visibleRoot || roots[roots.length - 1];
}

  function render(index, root) {
    const targetRoot = root || getRoot();
    const entry = TERMS[index];

    if (!targetRoot) {
      return {
        ok: false,
        reason: 'The word-of-the-day element is not currently in the DOM.',
        index: index
      };
    }

    if (!entry) {
      return {
        ok: false,
        reason: 'No dictionary entry exists at that index.',
        index: index
      };
    }

    const term = targetRoot.querySelector('[data-bro-term]');
    const meta = targetRoot.querySelector('[data-bro-meta]');
    const definition = targetRoot.querySelector('[data-bro-definition]');
    const examples = targetRoot.querySelector('[data-bro-examples]');

    if (!term || !meta || !definition || !examples) {
      return {
        ok: false,
        reason: 'The snippet is missing one or more required data-bro-* elements.',
        index: index
      };
    }

    term.textContent = entry.term;
    term.classList.toggle('is-long', entry.term.length >= 11);
    term.classList.toggle('is-very-long', entry.term.length >= 14);
    meta.textContent = entry.meta;
    definition.textContent = entry.definition;
    examples.replaceChildren();

    entry.examples.forEach(function (example) {
      const item = document.createElement('li');
      item.textContent = example;
      examples.appendChild(item);
    });

    examples.hidden = entry.examples.length === 0;
    targetRoot.dataset.broCurrentIndex = String(index);
    targetRoot.dataset.broCurrentTerm = entry.term;

    return {
      ok: true,
      index: index,
      entry: entry
    };
  }

  function next() {
    currentRoot = getRoot();
    currentIndex = (currentIndex + 1 + TERMS.length) % TERMS.length;
    storeIndex(currentIndex);
    return render(currentIndex, currentRoot);
  }

  function previous() {
    currentRoot = getRoot();
    currentIndex = (currentIndex - 1 + TERMS.length) % TERMS.length;
    storeIndex(currentIndex);
    return render(currentIndex, currentRoot);
  }

  function random() {
    currentRoot = getRoot();

    if (TERMS.length <= 1) {
      currentIndex = 0;
    } else {
      let nextIndex = currentIndex;
      while (nextIndex === currentIndex) {
        nextIndex = Math.floor(Math.random() * TERMS.length);
      }
      currentIndex = nextIndex;
    }

    storeIndex(currentIndex);
    return render(currentIndex, currentRoot);
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;

    let node = element;

    while (node && node !== document.documentElement) {
      const style = window.getComputedStyle(node);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number(style.opacity) === 0 ||
        node.hidden ||
        node.getAttribute('aria-hidden') === 'true' ||
        node.getAttribute('data-state') === 'closed'
      ) {
        return false;
      }

      node = node.parentElement;
    }

    const rect = element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth
    );
  }

  function check() {
    const nextRoot = getRoot();

    if (!nextRoot) {
      currentRoot = null;
      wasVisible = false;
      return {
        found: false,
        visible: false,
        index: currentIndex
      };
    }

    if (nextRoot !== currentRoot) {
      currentRoot = nextRoot;
      wasVisible = false;

      // Re-render the current entry when Shopify replaces the cart HTML.
      if (currentIndex >= 0) {
        render(currentIndex, currentRoot);
      }
    }

    const visible = isVisible(currentRoot);

    if (visible && !wasVisible) {
      next();
    }

    wasVisible = visible;

    return {
      found: true,
      visible: visible,
      index: currentIndex,
      term: currentIndex >= 0 ? TERMS[currentIndex].term : null
    };
  }

  function status() {
    const root = getRoot();

    return {
      loaded: true,
      termCount: TERMS.length,
      rootFound: Boolean(root),
      visible: isVisible(root),
      currentIndex: currentIndex,
      currentTerm: currentIndex >= 0 ? TERMS[currentIndex].term : null,
      script: document.querySelector('script[src*="bro-word-of-the-day.js"]')?.src || 'inline or renamed asset'
    };
  }

  function init() {
    currentIndex = readStoredIndex();
    check();

    if (pollTimer === null) {
      pollTimer = window.setInterval(check, POLL_INTERVAL);
    }

    document.addEventListener('shopify:section:load', check);
    document.addEventListener('shopify:section:unload', check);
    document.addEventListener('cart:updated', check);
    document.addEventListener('cart:refresh', check);

    console.info('[Bro Word of the Day] initialized', status());
    return status();
  }

  window.KoreanBrosWordOfDay = {
    init: init,
    check: check,
    next: next,
    previous: previous,
    random: random,
    render: function (index) {
      const normalized = Number(index);

      if (!Number.isInteger(normalized) || normalized < 0 || normalized >= TERMS.length) {
        return {
          ok: false,
          reason: 'Index must be an integer from 0 through ' + (TERMS.length - 1) + '.'
        };
      }

      currentIndex = normalized;
      storeIndex(currentIndex);
      return render(currentIndex, getRoot());
    },
    reset: function () {
      currentIndex = -1;
      storeIndex(currentIndex);
      wasVisible = false;
      return check();
    },
    status: status,
    terms: TERMS.slice()
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
